module.exports = __webpack_public_path__ + "static/media/Cow.bb64a282.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wordMark2/Cow.png
// module id = 867
// module chunks = 0